export default "__VITE_ASSET__CQZyeLGr__"